<template>
  <v-card color="transparent" flat class="mx-auto mt-2 mb-6" width=500 v-intersect="{
            handler: onIntersect,
            options: {
              threshold: [0, 0.5, 1.0]
            }
          }">
          <v-card-title v-if="name" class="mb-2">{{ $t('recruit.detail.name')+"："+name }}</v-card-title>
          <v-card-text v-if="position" class="py-0">{{ $t('recruit.detail.position')+"："+position }}</v-card-text>
          <v-card-text v-if="salary" class="py-0">{{ $t('recruit.detail.salary')+"："+salary }}</v-card-text>
          <v-card-text v-if="email" class="py-0">
            {{ $t('recruit.detail.email') }}：
            <a :href='"mailto:"+email+"?subject=应聘-"+name'>{{ email }}</a>
          </v-card-text>
          <v-card-text v-if='requests&&!allTitle' class="mb-2">{{ $t('recruit.detail.request') }}</v-card-text>
          <v-card-title v-else-if="requests" class="mb-2">{{ $t('recruit.detail.request') }}</v-card-title>
          <v-card-text
            v-for="(request,index) in requests" :key='"request"+index'
            class="py-0"
          >{{ (index+1)+"、"+request }}</v-card-text>
          <v-card-text v-if="responses&&!allTitle" class="mb-2">{{ $t('recruit.detail.response') }}</v-card-text>
          <v-card-title v-else-if="responses" class="mb-2">{{ $t('recruit.detail.response') }}</v-card-title>
          <v-card-text
            v-for="(response,index) in responses"
            :key='"response"+index'
            class="py-0"
          >{{ (index+1)+"、"+response }}</v-card-text>
         <v-card-text v-if="practice&&!allTitle" class="mb-2">{{ $t('recruit.detail.practice') }}</v-card-text>
          <v-card-title v-else-if="practice" class="mb-2">{{ $t('recruit.detail.practice') }}</v-card-title>
          <v-card-text
            v-for="(item,index) in practice"
            :key='"practice"+index'
            class="py-0"
          >{{ (index+1)+"、"+item }}</v-card-text>
          <v-card-actions>
              <v-row justify="center">
                <v-scale-transition origin="center center">
                <v-btn v-if='email&&showBtn'
                  :href='"mailto:"+email+"?subject=应聘-"+name'
                  color="#0F1D2D"
                  width="300"
                  height="50"
                  x-large
                  class="mt-6 white--text"
                  elevation="24"
                  tile
                >{{ $t('recruit.sendMailbtn') }}</v-btn>
                <v-btn v-else-if="showBtn"
                  :href='"mailto:suzhou@trans-cosmos.com.cn?subject=应聘-"+title'
                  color="#0F1D2D"
                  width="300"
                  height="50"
                  x-large
                  class="mt-6 white--text"
                  elevation="24"
                  tile
                >{{ $t('recruit.sendMailbtn') }}</v-btn>
                </v-scale-transition>
              </v-row>
          </v-card-actions>
        </v-card>
</template>

<script>
export default {
  name: "TciRecruitCard",
  data: () => ({
    showBtn: false
  }),
  props: {
    name: String,
    position: String,
    salary: String,
    email: String,
    requests: Array,
    responses: Array,
    practice: Array,
    title: String,
    allTitle: Boolean
  },
  methods: {
    onIntersect: function(entries){
      if(!this.showBtn){
        this.showBtn = entries[0].intersectionRatio >= 1;
      }
    }
  }
};
</script>
